import { graphql } from "@cappelendamm/crystallize-types/pim/gql";
export const getSkus = async (skus, { client }) => {
    const response = await client.pim.request(graphql(`
      query GetSkus($skus: [String!], $tenantId: ID!) {
        product {
          getVariants(skus: $skus, language: "no-nb", tenantId: $tenantId) {
            sku
          }
        }
      }
    `), { skus, tenantId: client.tenantId });
    return response.product.getVariants;
};
